import type { FilterTreeNode } from "../AppViewUtils.types";

export const FILTER_TO_EXECUTE_PARSE_ERROR =
  "Filter query: failed to parse filterToExecute";

export interface ParsedFilterQuery {
  filter: FilterTreeNode | null;
  parseError: Error | null;
}

// The raw JSON.parse error embeds a prefix of the input, which useLogger would
// send to Sentry. Callers get a synthetic error carrying only name and position.
const toSafeParseError = (error: unknown): Error => {
  const source = error as Error | undefined;
  const name = source?.name || "SyntaxError";
  const position = /at position \d+/.exec(source?.message ?? "")?.[0];
  const safeError = new Error(position ? `${name} ${position}` : name);
  safeError.name = name;
  return safeError;
};

export const parseFilterQuery = (query?: string | null): ParsedFilterQuery => {
  if (!query) {
    return { filter: null, parseError: null };
  }
  try {
    return { filter: JSON.parse(query) as FilterTreeNode, parseError: null };
  } catch (error) {
    return { filter: null, parseError: toSafeParseError(error) };
  }
};

export const safeRemoveStoredFilter = (key?: string): void => {
  if (!key) {
    return;
  }
  try {
    localStorage.removeItem(key);
  } catch {
    // Storage unavailable — the in-memory fallback still recovers the view.
  }
};
